import React from "react";
import { Navigate, Outlet } from "react-router-dom";
import { isLoggedIn } from "../../utils/AuthService";

const Public = ({ component: Component }) => {
  return !isLoggedIn() ? <Component /> : <Navigate to="/orders" />;
};

export default Public;
